<script lang="ts">
import { defineComponent } from 'vue';
import Headline from '@/components/headline.vue';
import FootballMatchSummary from './match-state/FootballMatchSummary.vue';
import ClipboardIcon from '@/components/clipboard-icon.vue';
import BasketballMatchSummary from './match-state/BasketballMatchSummary.vue';
import MultiSportMatchStateV2 from './match-state/MultiSportMatchStateV2.vue';
import TennisMatchSummary from './match-state/TennisMatchSummary.vue';
import BaseballMatchSummary from './match-state/BaseballMatchSummary.vue';
import { formatDate } from '@/utils/format';

export default defineComponent({
  name: 'MatchState',
  components: {
    ClipboardIcon,
    Headline,
    FootballMatchSummary,
    BasketballMatchSummary,
    MultiSportMatchStateV2,
    TennisMatchSummary,
    BaseballMatchSummary,
  },
  computed: {
    updates() {
      return this.fixture?.Updates?.length ? this.fixture.Updates : null;
    },
    matchState() {
      if (!this.updates) return null;

      if (this.updates.length === 1 || this.updates[0].Type === this.updates[1].Type)
        return this.updates[0];

      return this.updates.find(({ Type }: { Type: string }) => Type !== 'MultiSportMatchStateV2');
    },
    isStateAvailable() {
      return (
        this.fixture?.Feeds?.find(({ Type }: { Type: string }) => Type === 'MatchState')
          ?.IsLicensed || false
      );
    },
    isTradingAvailable() {
      return (
        this.fixture?.Feeds?.find(({ Type }: { Type: string }) => Type === 'TradingState')
          ?.IsLicensed || false
      );
    },
  },
  methods: { formatDate },
  data() {
    return {
      availableStates: [
        'FootballMatchSummary',
        'BasketballMatchSummary',
        'MultiSportMatchStateV2',
        'TennisMatchSummary',
        'BaseballMatchSummary',
      ],
      display: true,
      info: false,
    };
  },
  props: ['fixture'],
});
</script>

<template v-if="matchState">
  <headline class="my-2">
    <span class="cursor-pointer mr-1" @click="display = !display">
      <i
        :class="{
          pi: true,
          'pi-plus': !display,
          'pi-minus': display,
        }"
      />
      {{ matchState.Type }}
    </span>
    <template #counter>
      <span class="text-green-500">
        {{ formatDate(matchState.createdAt, 'YYYY-MM-DD HH:mm:ss') }}
      </span>
      [{{
        new Date(matchState.createdAt).getTime() -
        new Date(matchState.Data.MessageTimestampUtc).getTime()
      }}ms]
      {{ matchState.Id }}
      <clipboard-icon :text="matchState?.Id" class="text-sm mr-2" />
      <span class="mr-2 text-gray-600 dark:text-gray-400">
        Фид ставок:
        <span :class="isTradingAvailable ? 'text-green-500' : 'text-red-500'">
          {{ isTradingAvailable ? 'активен' : 'неактивен' }}
        </span>
      </span>
      <span class="text-gray-600 dark:text-gray-400">
        Фид состояния:
        <span :class="isStateAvailable ? 'text-green-500' : 'text-red-500'">
          {{ isStateAvailable ? 'активен' : 'неактивно' }}
        </span>
      </span>
      <i class="pi pi-info-circle text-sm ml-2" @click="info = !info" />
    </template>
  </headline>
  <transition name="slide">
    <div v-show="display" class="overflow-hidden">
      <template v-if="availableStates.includes(matchState.Type)">
        <component :is="matchState.Type" :update="matchState" :fixture="fixture" class="mb-3" />
      </template>
      <template v-else>
        <pre>
          {{ matchState }}
        </pre>
      </template>
    </div>
  </transition>
  <transition name="slide">
    <pre v-show="info" class="overflow-hidden ml-3 mb-2">{{ matchState }}</pre>
  </transition>
</template>

<style scoped lang="scss"></style>
